import React, {useState} from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import useTheme from '@mui/material/styles/useTheme'
import LoginIcon from '@mui/icons-material/Login'
import Collapse from '@mui/material/Collapse'

import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import DropDown from './DropDown'
import MobileNav from './MobileNav'
import { PAGES, SETTINGS, RESOURCES, MOBILE_NAV_ROUTES, isLoggedIn, routeVisible } from './routes'
import { logout } from '../../reducers/userReducer'

import { NavBarStyle } from '../styles'

const recommendedRoute = MOBILE_NAV_ROUTES.find(route => route.path === PAGES.recommended.path)
const chatbotRoute = MOBILE_NAV_ROUTES.find(route => route.path === PAGES.chatbot.path)

const NavBar = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const user = useSelector(state => state.user)
    const theme = useTheme()
    const medium_screen = theme.breakpoints.values.md

    const [resourceDropdown, setResourceDropdown] = useState(false)
    const [menuDropdown, setMenuDropdown] = useState(false)

    // if md screen or larger open the dropdown
    const dropDownOpen = (handler) => {
        if (window.innerWidth < medium_screen) {
            handler(false)
        } else {
            handler(true)
        }
    }

    const dropDownClose = (handler) => handler(false)

    const toggleDropDown = (handler, val) => handler(!val)

    const logoutHandler = () => {
        dispatch(logout())
        setMenuDropdown(false)
        navigate(PAGES.home.path)
    }

    return (
        <AppBar {...NavBarStyle.appbar.props}  sx={NavBarStyle.appbar.style} >
            <Container {...NavBarStyle.navContainer} >
                <Toolbar disableGutters>
                    <Link to={PAGES.home.path} style={NavBarStyle.reactLink} >
                        <Icon sx={NavBarStyle.navLogo}>
                            <img alt='UofT Logo' src='/static/logo.svg' />
                        </Icon>
                    </Link>
                    <Link to={PAGES.home.path} style={NavBarStyle.reactLink} >
                        <Typography {...NavBarStyle.navHeader.props} noWrap sx={NavBarStyle.navHeader.style}>
                            {PAGES.home.desktop_title}
                        </Typography>
                    </Link>

                    <MobileNav logoutHandler={logoutHandler}/>

                    <Box sx={NavBarStyle.linkContainer}>
                        <Link to={PAGES.about.path} style={NavBarStyle.reactLink} >
                            <Button sx={NavBarStyle.link}>
                                {PAGES.about.title}
                            </Button>
                        </Link>
                        <Link to={PAGES.start.path} style={NavBarStyle.reactLink} >
                            <Button sx={NavBarStyle.link}>
                                {PAGES.start.title}
                            </Button>
                        </Link>
                        <div onMouseEnter={() => dropDownOpen(setResourceDropdown)} onMouseLeave={() => dropDownClose(setResourceDropdown)}>
                            <Button onClick={() => toggleDropDown(setResourceDropdown, resourceDropdown)} sx={NavBarStyle.dropDownLink}>
                                {PAGES.resources.title} <ArrowDropDownIcon />
                            </Button>
                            <Box sx={NavBarStyle.dropDownBox}>
                                <Collapse in={resourceDropdown}>
                                    <DropDown links={RESOURCES} handler={setResourceDropdown} logout={false} admin={false}/>
                                </Collapse>
                            </Box>
                        </div>
                        {routeVisible(recommendedRoute, user) && (
                            <Link to={PAGES.recommended.path} style={NavBarStyle.reactLink} >
                                <Button sx={NavBarStyle.link}>
                                    {PAGES.recommended.title}
                                </Button>
                            </Link>
                        )}
                        <Link to={PAGES.tcairemResources.path} style={NavBarStyle.reactLink} >
                            <Button sx={NavBarStyle.link}>
                                {PAGES.tcairemResources.title}
                            </Button>
                        </Link>
                    </Box>

                    {routeVisible(chatbotRoute, user) && (
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', mr: 1 }}>
                            <Link to={PAGES.chatbot.path} style={NavBarStyle.reactLink} >
                                <Button
                                    sx={{ ...NavBarStyle.link, display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}
                                    startIcon={<ChatBubbleOutlineIcon />}
                                >
                                    {PAGES.chatbot.title}
                                </Button>
                            </Link>
                        </Box>
                    )}

                    {isLoggedIn(user)?
                        <Box onMouseLeave={() => dropDownClose(setMenuDropdown)} sx={NavBarStyle.userBox}>
                            <Tooltip title='Profile Options'>
                                <Button onClick={() => toggleDropDown(setMenuDropdown, menuDropdown)} sx={NavBarStyle.userText}>
                                    {user.name} <ArrowDropDownIcon />
                                </Button>
                            </Tooltip>
                            <Box sx={NavBarStyle.userDropDown}>
                                <Collapse in={menuDropdown}>
                                    <DropDown links={SETTINGS} handler={setMenuDropdown} logout={true} logoutHandler={logoutHandler} admin={user.staff}/>
                                </Collapse>
                            </Box>
                        </Box>:<Link to={PAGES.login.path} state={{ from: location.pathname + location.search }} style={NavBarStyle.reactLink} >
                            <Button sx={NavBarStyle.userText}>
                                {PAGES.login.title} <LoginIcon />
                            </Button>
                        </Link>
                    }
                </Toolbar>
            </Container>
        </AppBar>
    )
}

export default NavBar
